// extracted by mini-css-extract-plugin
module.exports = {"stylePagination":"Pagination_stylePagination__14qC5","buttonClass":"Pagination_buttonClass__3RPmp","paginationDiv":"Pagination_paginationDiv__kcstw"};